<template>
  <footer>
    <div class="box">
      <el-row class="row" style="display: flex;">
        <el-col class="r-el" :xs="12">
          <h4>
            <!-- <i class="iconfont">&#xe787;</i> -->
          關注我們</h4>
          <div class="r-link">
            <ul>
              <!-- <li><a class="iconfont" href="javascript:;">&#xe60c;</a></li> -->
              <li><a class="iconfont" href="https://facebook.com/ivecohongkong" target="_blank">&#xe628;</a></li>
              <!-- <li><a class="iconfont" href="javascript:;">&#xe75f;</a></li> -->
            </ul>
          </div>
        </el-col>
        <el-col class="r-el" :xs="12">
          <span>Star Auto Holding Ltd.</span>
        </el-col>
      </el-row>
    </div>
  </footer>
</template>

<script>
import Element from 'element-ui';  //Element插件

export default {
  name: 'Footer',
  data () {
    return {
      msg: ''
    }
  }
}
</script>

<style lang="stylus" ref="stylesheet/stylus" scoped>
  footer {
    background: #161c2a;
    color: #999999;
    padding: 10px 0;
    h4 {
      font-size: 14px;
      text-transform: uppercase;
      height: 40px;
      line-height: 40px;
      padding-left: 30px;
      margin: 0;
      color: #fff;
      display: inline-block;
      position: relative;
      float: left;
      i {
        font-size: 24px;
        position: absolute;
        left: 0;
      }
    }
    .r-link {
      display: block;
      float: left;
      margin: 0 0 0 10px;
      li {
        display: inline-block;
        a {
          font-size: 25px;
          color: #4d525c;
          padding: 2.5px 5px;
          display: inline-block;
        }
      }
    }
  }
  
  @media (min-width: 768px) {
    // footer {
    //   h4 {
    //     float: left;
    //   }
    //   .r-link {
    //     float: left;
    //     margin: 0 0 0 10px;
    //   }
    // }
  }

  @media (min-width: 992px) {
  }

  @media (min-width: 1200px) {
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue